import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { List as Component } from '../list';
import type { IDeps, TList } from '../models';

import styles from './desktop.css';

export const ListDesktop = createWidget<IDeps, TList>(
    { styles },
    { priorityStyler: true }
)(Component);
